import { axios } from '@/plugins/axios';
import { PostTransmettreRequest, PostTransmettreRequestPartial } from './types';

export function postTransmettreAATComplet(
	postTransmettreRequestComplet: PostTransmettreRequest
) {
	return axios.post('/aat-api/transmettreAATComplet', postTransmettreRequestComplet);
}

export function postTransmettreAATPartiel(
	postTransmettreRequestPartial: PostTransmettreRequestPartial
) {
	return axios.post('/aat-api/transmettreAATPartiel', postTransmettreRequestPartial);
}
